import { Avatar, AvatarProps } from '../Avatar';
import { withMewsSrcSet } from '../Hoc';
import { MewsImageProps } from '../Hoc/MewsImageProps';

const defaultAvatarRatio = 1;

export type MewsAvatarProps = MewsImageProps & AvatarProps;

export default ({ ratio = defaultAvatarRatio, ...other }: MewsAvatarProps) =>
    withMewsSrcSet(Avatar)({ ratio, ...other });
